type PushAction = {
  type: 'PUSH_FLASH_MESSAGE';
  message: FlashMessageType;
};
type RemoveAction = {
  type: 'REMOVE_FLASH_MESSAGE';
  id: string;
};
type ClearAction = {
  type: 'CLEAR_FLASH_MESSAGES';
};
export type Action = PushAction | RemoveAction | ClearAction;
export const pushFlashMessage = (message: FlashMessageType): PushAction => ({
  type: 'PUSH_FLASH_MESSAGE',
  message,
});
export const removeFlashMessage = (id: string): RemoveAction => ({
  type: 'REMOVE_FLASH_MESSAGE',
  id,
});
export const clearFlashMessages = (): ClearAction => ({
  type: 'CLEAR_FLASH_MESSAGES',
});
